export default __webpack_public_path__ + "static/media/background.e1077608.jpg";